import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KbLoadingService {
  loadingSub$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingMap: Map<string, boolean> = new Map<string, boolean>();
  private hideTimeout: ReturnType<typeof setTimeout> | null = null;
  public FromSearchBox: boolean = true;

  setLoading(loading: boolean, url: string): void {
    if (!url) {
      throw new Error(
        'The request URL must be provided to the LoadingService.setLoading function'
      );
    }
    if (loading && this.checkCallFromSearchBox(url, Boolean)) {
      this.loadingMap.set(url, loading);

      if (this.hideTimeout !== null) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.loadingSub$.next(true);
    } else if (!loading && this.loadingMap.has(url)) {
      this.loadingMap.delete(url);
    }
    if (this.loadingMap.size === 0) {
      this.loadingSub$.next(false);
      this.hideTimeout = setTimeout(() => {
        this.hideTimeout = null;
        if (this.loadingMap.size === 0) {
          this.loadingSub$.next(false);
        }
      }, 300);
    }
  }

  private checkCallFromSearchBox(url, boolean) {
    if (url.includes('/products/search')) {
      return boolean && this.FromSearchBox;
    }
    return boolean;
  }
}
